import MembershipPlansPage from "./manage-membership-plans";
import PartnerPage from "./manage-partner";
import ProductCategories from "./manage-product-category";
import ManageSwiperImages from "./manage-swiper-images";
import {
  PRODUCT_CATEGORY_TITLE,
  PRODUCT_TITLE,
  SUPPORT_PROMOTIONS,
} from "@/config";
import ManageMembershipPlanVouchers from "@/router/manage-membership-plan-vouchers";
import MamageProduct from "@/router/manage-product";
import ManagePromotions from "@/router/manage-promotions";
import ManageVouchers from "@/router/manage-vouchers";

export const routerInfo = [
  // {
  //   path: "/manage-product",
  //   title: `管理${PRODUCT_TITLE}`,
  //   Component: MamageProduct,
  // },
  {
    path: "/manage-product-category",
    title: `管理${PRODUCT_CATEGORY_TITLE}类型`,
    Component: ProductCategories,
  },

  {
    path: "/manage-product",
    title: "管理用户",
    Component: MamageProduct,
  },
  {
    path: "/manage-swiper-images",
    title: "管理首页轮播图",
    Component: ManageSwiperImages,
  },

  // {
  //   path: "/manage-vouchers",
  //   title: "管理优惠券",
  //   Component: ManageVouchers,
  // },
  // {
  //   path: "/manage-membership-plans",
  //   title: "管理会员计划",
  //   Component: MembershipPlansPage,
  // },
  // {
  //   path: "/manage-membership-plan-vouchers",
  //   title: "管理会员赠送优惠券",
  //   Component: ManageMembershipPlanVouchers,
  // },
  // {
  //   path: "/manage-product",
  //   title: "查看会员销售记录",
  //   Component: MamageProduct,
  // },
];

if (SUPPORT_PROMOTIONS === "true") {
  routerInfo.push(
    {
      path: "/manage-promotions",
      title: "管理推广套餐",
      Component: ManagePromotions,
    },
    // TODO
    {
      path: "/manage-product",
      title: "查看推广销售记录",
      Component: MamageProduct,
    },
  );
}
